<template>
  <div>
    <footer class="po-r mt20 w100 tx-c white flex-box al-c ju-c">
      <img class="mr10" :src="`${baseUrl}images/logo-footer.png`">
      <!-- <span class="mr10">Copyright © 2019 All rights reserved</span> -->
      <span class="mr10">Copyright © 南宁职业技术学院版权所有</span>
      <!-- <span class="mr10">南宁职业技术学院版权所有</span> -->
      <!-- <span>技术支持：南宁市迈越软件有限责任公司</span> -->
    </footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  },
  computed: {},
  mounted() {},
  methods: {}
};
</script>

<style scoped>
footer {
  height: 40px;
  line-height: 40px;
  background: #475eb7;
  z-index: 60;
}
</style>
